import { autoinject } from "aurelia-framework";
import { RoleModel } from "../../../../../models/manage/roles.models";
import { ManageRolesClientService } from "../../../../../services/manage/manage-roles.service";
import { I18N } from "aurelia-i18n";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";
import { Guid } from "../../../../../utilities/guid";

@autoinject
export class ManageRole {

    private _saveOperation: () => void;
    private _cancelOperation: () => void;
    private _originalRoleInEdit: RoleModel;

    public title: string = "";
    public roleInEdit: RoleModel;
    public roleId: number;
    public departmentId: number;

    constructor(private manageRolesClientService: ManageRolesClientService,
        private i18N: I18N,
        private notificationService: NotificationClientService) { }

    getEmptyRole(): RoleModel {
        return {
            roleId: 0,
            roleName: "",
            description: "",
            departmentId: this.departmentId,
            isManager: false,
            isActive: true,
            isDefault: false,
            identifier: Guid.generateGuid()
        }
    }

    areThereUnsavedChanges() {
        if (this._originalRoleInEdit.roleName != this.roleInEdit.roleName) return true;
        if (this._originalRoleInEdit.isManager != this.roleInEdit.isManager) return true;
        if (this._originalRoleInEdit.isDefault != this.roleInEdit.isDefault) return true;

        return false;
    }

    activate(model: any) {
        this.roleId = model.roleId;
        this.departmentId = model.departmentId;
        this._cancelOperation = model.cancelOperation;
        this._saveOperation = model.saveOperation;
        this.title = model.title;
        this.initializeRole();
    }

    save() {
        return new Promise<void>((resolve, reject) => {
            if (!this.areThereUnsavedChanges()) {
                this.notificationService.show(this.i18N.tr('no-changes-performed-text'), this.i18N.tr('there-were-no-changes-to-save-text'), NotificationType.Info);
                resolve();
                return;
            }

            if (!this.roleInEdit.roleName) {
                this.roleInEdit.roleName = this.i18N.tr('default-role-name');
            }

            this.manageRolesClientService.saveRole({ role: this.roleInEdit })
                .then(response => {
                    if (response.isSuccess) {
                        this.notificationService.show(this.i18N.tr('successfully-saved-text'), this.i18N.tr('successful-role-saving-description'), NotificationType.Success);
                        this._saveOperation();
                        resolve();
                    }
                    else {
                        this.notificationService.show(this.i18N.tr('error-text'), this.i18N.tr('role-could-not-be-found-text'), NotificationType.Error);
                        reject();
                    }
                })
                .catch(response => {
                    if (!response) {
                        this.notificationService.show(this.i18N.tr('error-text'), this.i18N.tr('error-message-saving-role'), NotificationType.Error);
                    }
                    reject();
                });
        });
    }

    cancel() {
        this._cancelOperation();
    }

    initializeRole() {
        if (this.roleId == 0) {
            this.roleInEdit = this.getEmptyRole();
            this._originalRoleInEdit = CloneHelper.clone(this.roleInEdit);
        }
        else if (this.roleId) {
            this.manageRolesClientService.getRole({ roleId: this.roleId })
                .then(x => {
                    this.roleInEdit = x.role;
                    this._originalRoleInEdit = CloneHelper.clone(this.roleInEdit);
                })
        }
    }
}
